import styled from 'styled-components';

import { theme } from '../../theme';
import { ColorVariantEnum } from '../text';
import { getColorFromColorVariantProp } from '../text/text.styles';

export interface IBold {
	colorVariant?: ColorVariantEnum | ColorVariantEnum[];
}

export const Bold = styled.span<IBold>`
	font-family: ${theme.typography.fonts.bold};
	color: ${(props) =>
		getColorFromColorVariantProp({
			colorVariant: props.colorVariant,
			fallback: ColorVariantEnum.DARK,
		})}};
`;
